// import "@pnp/polyfill-ie11";
import "core-js/stable";
import "regenerator-runtime/runtime";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import {
  mountPrenotazioneCamera,
  mountPrenotazioneEsperienza,
  mountPrenotazioneTavolo
} from "./mount-static";

setTimeout(() => {
  if (window.runPrenotazioneCamera) {
    mountPrenotazioneCamera();
  } else if (window.runPrenotazioneEsperienza) {
    mountPrenotazioneEsperienza();
  } else if (window.runPrenotazioneTavolo) {
    mountPrenotazioneTavolo();
  }
}, 200);
